import { createApp } from 'vue';
import { createRouter, createWebHistory } from 'vue-router';
import ElementPlus from 'element-plus'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import 'element-plus/dist/index.css'
import App from './App.vue';
import MyFooter from "./components/partials/MyFooter.vue";
import HomePage from "./components/home/HomePage.vue";
import DiscoverPage from "./components/discover/DiscoverPage.vue";
import ColorRefPage from "./components/discover/ColorRefPage.vue";
import ContactPage from "./components/contact/ContactPage.vue";
import ChromosomePage from "./components/discover/ChromosomePage.vue";
import ExcelFakerPage from './components/discover/ExcelFakerPage.vue';
import HiiTPage from './components/discover/HiiTPage.vue';
import PrivacyPolicyPage from './components/legal/PrivacyPolicyPage.vue';
import TermsOfServicePage from './components/legal/TermsOfServicePage.vue';
import AboutPage from './components/about/AboutPage.vue';
import axios from 'axios';

const app = createApp(App);

const router = createRouter({
	history: createWebHistory(),
	routes: [
		{ path: "/", component: HomePage },
		{ path: "/work", component: DiscoverPage },
		{ path: "/contact", component: ContactPage },
		{ path: "/colors", component: ColorRefPage },
		{ path: "/chromosome", component: ChromosomePage },
		{ path: "/excelfaker", component: ExcelFakerPage },
		{ path: "/hiit", component: HiiTPage },
		{ path: "/privacy", component: PrivacyPolicyPage },
		{ path: "/terms", component: TermsOfServicePage },
		{ path: "/about", component: AboutPage },
	]
});

app.use(ElementPlus)
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}
app.component("my-footer", MyFooter);

app.use(router);

app.config.globalProperties.$axios = axios;

app.mount('#app');
